import React, { useState } from "react";
import { useReactTable, getCoreRowModel, getPaginationRowModel, getSortedRowModel, getFilteredRowModel } from "@tanstack/react-table";
import "../../Assets/Styles/NetflixList.css";

export function DataTable({ columns, data }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const table = useReactTable({
        data: data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <div className="netflix-table-container">
            <div className="netflix-filter-group">
                <input
                    type="text"
                    placeholder="Filtre par Email ..."
                    className="netflix-input-filter"
                    value={table.getColumn("userEmail")?.getFilterValue() || ""}
                    onChange={(event) => table.getColumn("userEmail")?.setFilterValue(event.target.value)}
                />

                <input
                    type="text"
                    placeholder="Filtre par Nom ..."
                    className="netflix-input-filter"
                    value={table.getColumn("userName")?.getFilterValue() || ""}
                    onChange={(event) => table.getColumn("userName")?.setFilterValue(event.target.value)}
                />
            </div>

            <div className="netflix-table-wrapper">
                <table className="netflix-table">
                    <thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                    <th key={header.id} className="netflix-table-header">
                                        {header.isPlaceholder ? null : header.column.columnDef.header}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.length ? (
                            table.getRowModel().rows.map((row) => (
                                <tr key={row.id} className="netflix-table-row">
                                    {row.getVisibleCells().map((cell) => (
                                        <td key={cell.id} className="netflix-table-cell">
                                            {cell.column.columnDef.cell ? cell.column.columnDef.cell({ row }) : cell.getValue()}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="netflix-no-data">
                                    Pas de comptes disponibles.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
